import { createStyles } from '../../../../../styles/helpers'

const useStyles = createStyles({
  pbContainerReset: {
    width: 'unset'
  }
})

export default useStyles
